<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let isActive: boolean = false;

  const dispatch = createEventDispatcher();
  function handleClick() {
    dispatch("click");
  }
</script>

<button
  class="flex flex-row py-1.5 px-2 font-medium text-sm gap-2 items-center whitespace-nowrap text-zinc-300 border border-transparent"
  class:active={isActive}
  class:inactive={!isActive}
  on:click={handleClick}
>
  <slot />
</button>

<style lang="postcss">
  .inactive:hover {
    @apply bg-white/10 rounded-lg;
  }

  .active {
    @apply rounded-lg bg-primary/20 text-primary border-primary/5;
  }
</style>
